/**
 * Rows a datasource table asks the route for at a time. The route's own default, and under its
 * cap of 200.
 * @see [ATT-154 route contract](../../../../docs/mockups/ai-agents/ai-chat/AiChat_CrossRepoHandoff.md)
 */
export const DATASOURCE_PAGE_SIZE = 100;

/** The most rows the route hands out in one page. A chart reads a whole datasource in these. */
export const DATASOURCE_ROUTE_MAX_LIMIT = 200;

/** Postgres date types. A cell of one is a `YYYY-MM-DD` string, shown as a date. */
export const DATE_PG_TYPES = ['date'];

/** Postgres number types. A cell of one is shown right-aligned, as a number. */
export const NUMERIC_PG_TYPES = [
  'integer', 'bigint', 'smallint', 'double precision', 'real', 'numeric',
];

/** Postgres JSON types. A cell of one is shown as compact JSON. */
export const JSON_PG_TYPES = ['json', 'jsonb'];

export const BOOLEAN_PG_TYPE = 'boolean';

/** Marks an array type, as `format_type` writes it: `text[]`, `integer[]`. */
export const ARRAY_PG_TYPE_SUFFIX = '[]';
